import { closeResetPasswordModal } from '../State/resetPasswordModal'

export default () => (dispatch) => {

  dispatch(closeResetPasswordModal())
  
}
